import React, { useEffect } from 'react';

import {
  usePasswordResetRequestFormState,
  usePasswordResetRequestFormActions
} from './PasswordResetRequestFormContext';
import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';
import CenterFill from '../../Shared/UI/CenterFill/components/CenterFill';

import { createAndSendPasswordResetToken } from '../../Account/components/restApi';

const PasswordResetRequestForm = ({ handleCloseWizard, previousStep }) => {
  const state = usePasswordResetRequestFormState();
  const {
    initializeState,
    updateEmail,
    onResponse,
    onError,
  } = usePasswordResetRequestFormActions();

  useEffect(() => {
    initializeState();
  }, []);

  const handleSubmit = () => {
    createAndSendPasswordResetToken({
      onResponse,
      onError,
      body: {
        email: state?.passwordResetRequestForm?.email || '',
        authenticityToken: document.querySelector("meta[name='csrf-token']").getAttribute("content")
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Email" id="email">
        <Input
          type="email"
          name="account[email]"
          value={state?.passwordResetRequestForm?.email || ''}
          onChange={(e) => updateEmail(e.target.value)}
        />
      </Field>

      <CenterFill>
        <Button
          variant="ghost"
          onClick={previousStep}
        >
          Back To Login
        </Button>
      </CenterFill>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              handleCloseWizard();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Request Reset
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default PasswordResetRequestForm;
